<template>
  <div class="swiper !overflow-visible">
    <div class="swiper-wrapper my-[80px] max-w-screen-md">
      <div
        v-for="(image, index) in slice.primary.gallery"
        :key="index"
        class="swiper-slide"
        :class="`slide--${index}`"
      >
        <PrismicImage :field="image.image" />
        <caption
          class="my-2 block text-left"
          data-swiper-parallax-x="-300"
        >
          {{ image.image.alt }}
        </caption>
      </div>
    </div>

    <!-- If navigation buttons are needed -->
    <div class="swiper-pagination" />
    <ArrowLeft class="swiper-button-prev !w-20" />
    <ArrowRight class="swiper-button-next !w-20" />
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import ArrowRight from "~/assets/svgs/arrow_right.svg";
import ArrowLeft from "~/assets/svgs/arrow_left.svg";

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
const props = defineProps(
  getSliceComponentProps<Content.ImageGallerySlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);

onMounted(() => {
  // init Swiper:

  const swiperCarousel = new Swiper(".swiper", {
    direction: "horizontal",
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    loopAdditionalSlides: 1,

    modules: [Navigation, Pagination],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
  });
},
);
</script>
